import { toast } from 'react-toastify';
import { formatMessage, getPagesMessages } from '../i18n';

export type GalleryPurgeBatch = {
  deleted?: string[];
  hasMore?: boolean;
};

const MAX_BATCHES = 50;
const inflight = new Map<string, Promise<number>>();

/** Gọi API xóa gallery ≥ 1 năm, mỗi lần tối đa 100, đến khi hết. */
export async function runGalleryYearPurge(
  requestBatch: () => Promise<GalleryPurgeBatch | undefined>,
  options?: { toast?: boolean }
): Promise<number> {
  let total = 0;
  for (let i = 0; i < MAX_BATCHES; i += 1) {
    const batch = await requestBatch();
    const deleted = batch && Array.isArray(batch.deleted) ? batch.deleted : [];
    total += deleted.length;
    if (deleted.length === 0 || !batch?.hasMore) break;
  }
  if (total > 0 && options?.toast) {
    toast.success(formatMessage(getPagesMessages().common.purgedOldGalleries, { n: total }));
  }
  return total;
}

/** Cùng một key đang chạy thì dùng chung kết quả (StrictMode mount 2 lần). */
export function runGalleryYearPurgeOnce(
  key: string,
  requestBatch: () => Promise<GalleryPurgeBatch | undefined>,
  options?: { toast?: boolean }
): Promise<number> {
  const existing = inflight.get(key);
  if (existing) return existing;
  const pending = runGalleryYearPurge(requestBatch, options).finally(() => {
    inflight.delete(key);
  });
  inflight.set(key, pending);
  return pending;
}
